import React, { Component } from 'react';
import UserInfo from 'components/user/UserInfo.js';
import Tone from 'tone';
import ConditionedComponent from 'components/ConditionedComponent.js';
import PasswordModal from 'components/modals/PasswordModal.js';
import UniversalNavigator from 'components/UniversalNavigator.js';
import UserProfileDetails from 'components/user/UserProfileDetails.js';
import ProfileNavigatorComponent  from './ProfileNavigatorComponent.js';
import { connect } from "react-redux";
import ethereum from 'decentralized/ethereum.js';
import Sequencer from 'components/v2/Sequencer.js';
import {setIsPlayingMix} from 'actions/index.js';
import {setLoadingSequence} from 'actions/index.js';
import {setUserHasEditsToSave} from 'actions/index.js';
import {setCurrentUserMix} from 'actions/index.js';
import {setSpotlightTracks} from 'actions/index.js';
import MultiSequencerEngine from 'engine/MultiSequencerEngine';
import UserMix from 'repos/UserMix.js';
import EthereumInstructions from 'components/user/EthereumInstructions.js';
import 'User.scss';
import {MIXES} from 'constants/user-view-modes.js';
import {LOW_SAMPLE_RATE, MID_SAMPLE_RATE} from 'constants/sample-rates.js';

class UserComponent extends Component {
    constructor(props) {
        super(props);

        if (navigator.platform === 'MacIntel') {
            Tone.setContext(new AudioContext({sampleRate: MID_SAMPLE_RATE}));
        } else {
            Tone.setContext(new AudioContext({sampleRate: LOW_SAMPLE_RATE}));
        }

        var userName = props.match.params.userId != undefined ? 
            props.match.params.userId :
            undefined;

        this.state = {
            mixes: [],
            profile: undefined,
            userName: userName,
            hasEthereum: true,
            loadedUser: false,
            userId: undefined,
            userNameNotFound: false,
            sequencerEngineEditing: undefined,
            spotlightTracks: [],
            isPermissionedUser: userName === undefined,
        };

        Tone.context.latencyHint = 'balanced';

        this.props.setIsPlayingMix(true);
        this.loadProfile();

        this.multiSequencerEngine = new MultiSequencerEngine(this.props.store);
        ethereum.crypto.store = this.props.store;
        this.onClickSave = this.onClickSave.bind(this);
    }

    onClickSave() {
        let spotlightTracks = this.props.spotlightTracks.map(s => s.id);
        let profile = this.props.profile;
        if (profile === undefined) {
            profile = {mixes: []};
        }
        profile.spotlightTracks = spotlightTracks;
        if (this.props.currentMix !== undefined) {
            this.addEditedMix(new UserMix().fromJson(this.props.currentMix));
        }
        profile.mixes = this.state.mixes.map(m => m.getJson(false));
        ethereum.users.setProfile(profile);
        this.props.setUserHasEditsToSave(false);
    }

    deleteTrack(sequence) {
        let sequencerEngine = this.multiSequencerEngine.getSequencerEngine(sequence.id);
        if (sequencerEngine !== undefined) { 
            if (sequencerEngine.playing) {
                sequencerEngine.stop();
            }
            setTimeout(() => {
                this.multiSequencerEngine.unloadTrack(sequence.id);
            }, 5000);
        }

        if (this.props.viewMode === MIXES) {
            let mix = new UserMix().fromJson(this.props.currentMix);
            mix.deleteTrack(sequence);
            this.props.setCurrentUserMix(mix.getJson());
            this.props.setUserHasEditsToSave(true);
        } else {
            let spotlightTracks = [... this.props.spotlightTracks];
            let id = spotlightTracks.indexOf(sequence);
            spotlightTracks.splice(id, 1);
            this.props.setSpotlightTracks(spotlightTracks);
            this.props.setUserHasEditsToSave(true);
        }
    }

    async loadMixes(profile) {
        if (profile === undefined || profile.mixes === undefined) {
            return;
        }

        let mixes = profile.mixes.map(m => new UserMix().fromJson(m));
        this.setState({
            mixes: mixes
        });
    }

    async loadSpotlightTracks(profile) {
        if (profile === undefined) {
            this.props.setSpotlightTracks([]);
        } else {
            let tracks = profile.spotlightTracks;
            console.log('loading spotlight tracks profile.tracks = ');
            console.log(tracks);
            let loadedTracks = [];
            for (let i in tracks) {
                loadedTracks.push(new Promise(async (resolve, reject) => {
                    resolve(this.convertSequence(await ethereum.getSequence(tracks[i])));
                }));
            }
            this.props.setSpotlightTracks(await Promise.all(loadedTracks));
        }
    }

    convertSequence(sequence) {
        return {...sequence, name: sequence.title, id: sequence.newSequence};
    }

    addTrack(sequence) {
        console.log('add track = ');
        console.log(sequence);
        if (this.props.viewMode === MIXES) {
            let mix = new UserMix().fromJson(this.props.currentMix);
            mix.tracks.push(sequence);
            this.props.setCurrentUserMix(mix.getJson());
            this.props.setUserHasEditsToSave(true);
        } else {
            this.props.setUserHasEditsToSave(true);
            this.props.setSpotlightTracks(this.props.spotlightTracks.concat([sequence]));
        }
    }

    addEditedMix(editedMix) {
        let mixes = [];
        let replacedMix = false;
        for (let i in this.state.mixes) {
            let mix = this.state.mixes[i];
            if (mix.id === editedMix.id) {
                mixes.push(editedMix);
                replacedMix = true;
            } else {
                mixes.push(mix);
            }
        }

        if (!replacedMix) {
            mixes.push(editedMix);
        }

        this.setState({mixes: mixes});
    }

    onClickDeleteMix(mixToDelete) {
        let indexToDelete = undefined;
        for (let i in this.state.mixes) {
            if (this.state.mixes[i].id === mixToDelete.id) {
                indexToDelete = i;
                break;
            }
        }

        if (indexToDelete !== undefined) {
            let mixes = [... this.state.mixes];
            mixes.splice(indexToDelete, 1);
            this.setState({mixes: mixes});
            this.props.setUserHasEditsToSave(true);
        }
    }

    async doesUserOwnPage() {
        let own = this.state.userId === await ethereum.getUser() ||
            this.state.userId === undefined;
        return own;
    }

    async loadProfile() {
        try {
            if (this.state.userName !== undefined) {
                let isAvailable = await ethereum.users.isUserNameAvailable(this.state.userName);
                if (!isAvailable) {
                    this.state.userId = await ethereum.users.getUserId(this.state.userName);
                } else {
                    this.setState({userNameNotFound: true, userLoaded: true});
                    return;
                }
            } 
            let profile = await ethereum.users.getProfile(this.state.userId);

            this.setState({profile: profile, userLoaded: true});
            this.loadMixes(profile);
            this.loadSpotlightTracks(profile);
        } catch (err) {
            if (err == 'no user name') {
            } else if (err === 'no profile') {
                this.setState({userLoaded: true});
            } else if (err === 'no ethereum') {
                // give instructions for setting up metamask
                this.setState({hasEthereum: false});
            }
        }

        try {
            let userName = await ethereum.users.getUserName(this.state.userId);
            this.setState({userName: userName});
        } catch (err) {
            console.log("error loading username " + err);
        }
    }

    onEditSequence(engine) {
        this.setState({sequencerEngineEditing: engine});
    }

    onGoBack() {
        this.setState({sequencerEngineEditing: undefined});
    }

    render() {
        if (this.state.userNameNotFound) {
            return (
                <div className="">
                  User name not found
                </div>
            );
        }
        
        let userProfileDetails = (
            <UserProfileDetails
              userLoaded={this.state.userLoaded}
              userId={this.state.userId}
              onClickDeleteMix={(mix) => this.onClickDeleteMix(mix)}
              mixes={this.state.mixes}
              currentMix={this.props.currentMix}
              onClickSave={() => this.onClickSave()}
              spotlightTracks={this.props.spotlightTracks}
              sequencerEngineEditing={this.state.sequencerEngineEditing}
              multiSequencerEngine={this.multiSequencerEngine}
              setIsPlayingMix={(x) => this.props.setIsPlayingMix(x)}
              isEditing={this.state.userId === undefined}
              ethereum={ethereum}
              addEditedMix={(mix) => this.addEditedMix(mix)}
              onDeleteTrack={(s) => this.deleteTrack(s)}
              viewMode={this.props.viewMode}
              addTrack={(t) => this.addTrack(t)}
              setLoadingSequence={this.props.setLoadingSequence}
              onEditSequence={(sequencerEngine) => this.onEditSequence(sequencerEngine)}
              loadedTracks={this.props.loadedTracks}
              isPlaying={this.props.isPlaying}
              store={this.props.store}
              profile={this.state.profile}/>);

        if (this.state.sequencerEngineEditing) {
            return (
                <div>
                <Sequencer
                  onGoBack={() => this.onGoBack()}
                  store={this.props.store}
                  sequencerEngine={this.state.sequencerEngineEditing}/>

                  {userProfileDetails}
                </div>
            );
        }

        return (
            <div className="user-page">
             <UniversalNavigator/>
             <PasswordModal crypto={ethereum.crypto} show={true}/>
             <ConditionedComponent condition={this.state.hasEthereum}>
                <div className="profile-container">
                  <div className="banner">
                    <UserInfo
                      onUserNameUpdated={(userName) => this.setState({userName: userName})}
                      userId={this.state.userId}
                      isEditing={this.state.userId === undefined}
                      ethereum={ethereum}
                      userName={this.state.userName}
                      profilePicture={this.state.profilePicture}
                      profile={this.state.profile}/>
                  </div>
                  <ProfileNavigatorComponent
                    ethereum={ethereum}
                    guilds={ethereum.guilds}
                    userName={this.state.userName}
                    userId={this.state.userId}
                    isEditing={this.state.userId === undefined}
                    onClickSave={this.onClickSave}/>
                  {userProfileDetails}
                </div>
              </ConditionedComponent>
              <ConditionedComponent condition={!this.state.hasEthereum}>
                <div className="profile-container">
                  <div className="profile-details">
                    <EthereumInstructions/>
                 </div>
                </div>
              </ConditionedComponent>
              </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setIsPlayingMix: isPlayingMix => dispatch(setIsPlayingMix(isPlayingMix)),
        setLoadingSequence: (id, sequence) => dispatch(setLoadingSequence(id, sequence)),
        setUserHasEditsToSave: (hasEdits) => dispatch(setUserHasEditsToSave(hasEdits)),
        setCurrentUserMix: (currentMix) => dispatch(setCurrentUserMix(currentMix)),
        setSpotlightTracks: (tracks) => dispatch(setSpotlightTracks(tracks)),
    };
};

const mapStateToProps = state => {
    return {
        viewMode: state.user.viewMode,
        currentMix: state.user.currentMix,
        loadedTracks: state.user.loadedTracks,
        isPlaying: state.sequencer.isPlaying,
        spotlightTracks: state.user.spotlightTracks
    };
};
 
export default connect(mapStateToProps, mapDispatchToProps)(UserComponent);
